import { appStores, brand } from "../siteContent";
import { AppFeatureShowcase } from "./AppFeatureShowcase";
import { NavLink } from "./NavLink";

function PlatformIcon({ platform }) {
  if (platform === "Android") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M7 8h10a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2h-1V21a1 1 0 0 1-2 0v-2.5h-4V21a1 1 0 0 1-2 0v-2.5H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2Z" />
        <path d="m8 7-1.4-2M16 7l1.4-2M8.5 11.5h.01M15.5 11.5h.01" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="6" y="2" width="12" height="20" rx="3" />
      <path d="M10 5h4M10 19h4" />
    </svg>
  );
}

function StoreCard({ store, className }) {
  return (
    <a
      className={`app-store-card ${className}`}
      href={store.url}
      target="_blank"
      rel="noreferrer"
      aria-label={`Download Aspirant CSS for ${store.platform} from ${store.storeName}`}
    >
      <span className="app-store-icon">
        <PlatformIcon platform={store.platform} />
      </span>
      <span className="app-store-copy">
        <small>Download free on</small>
        <strong>{store.storeName}</strong>
        <span>Aspirant CSS for {store.platform} · Version {store.version}</span>
      </span>
      <span className="app-store-arrow" aria-hidden="true">↗</span>
    </a>
  );
}

export function AppMarketingPage({ page, navigate }) {
  return (
    <article className="app-marketing-page" aria-labelledby="app-marketing-title">
      <header className="app-marketing-intro">
        <div className="app-marketing-brand">
          <img src={brand.logo} alt="Aspirant CSS app icon" width="88" height="88" />
          <div>
            <span className="section-eyebrow">Android and iPhone app</span>
            <p className="app-marketing-kicker">CSS · MPT · PMS preparation in Pakistan</p>
          </div>
        </div>
        <h1 id="app-marketing-title">Aspirant CSS App for Android and iPhone</h1>
        <p>
          Prepare CSS, MPT and PMS with structured lessons, solved written
          papers, past-paper MCQs, full mocks, vocabulary, current affairs,
          notes and progress tracking in one focused mobile study app.
        </p>
        <div className="app-store-grid" aria-label="Download Aspirant CSS">
          <StoreCard store={appStores.android} className="is-android" />
          <StoreCard store={appStores.ios} className="is-ios" />
        </div>
      </header>

      <AppFeatureShowcase navigate={navigate} mode="app" />

      <section className="app-marketing-details">
        <div>
          <span className="contact-card-label">Built for consistent study</span>
          <h2>Learn online and continue available work offline</h2>
          <p>
            Available learning material, locally saved notes and study progress
            remain accessible without a connection. Live news, account sync and
            newly published updates require internet access.
          </p>
          <p>
            English is the primary app language, with Urdu support in relevant
            Islamic Studies and MPT learning areas.
          </p>
        </div>
        <div className="app-marketing-links">
          <NavLink to="/css-past-papers" className="app-marketing-link" onNavigate={navigate}>
            Explore solved papers <span>→</span>
          </NavLink>
          <NavLink to="/mpt-past-papers" className="app-marketing-link" onNavigate={navigate}>
            Explore MPT practice <span>→</span>
          </NavLink>
          <NavLink to="/privacy-policy" className="app-marketing-link" onNavigate={navigate}>
            Privacy Policy <span>→</span>
          </NavLink>
          <NavLink to="/terms-of-use" className="app-marketing-link" onNavigate={navigate}>
            Terms of Use <span>→</span>
          </NavLink>
          <NavLink to="/contact" className="app-marketing-link" onNavigate={navigate}>
            Contact Support <span>→</span>
          </NavLink>
        </div>
      </section>

      {page?.faq?.length ? (
        <section className="app-faq-section" aria-labelledby="app-faq-title">
          <span className="section-eyebrow">App questions</span>
          <h2 id="app-faq-title">Before you download Aspirant CSS</h2>
          <div className="faq-list">
            {page.faq.map((item) => (
              <details key={item.question} className="faq-item">
                <summary>{item.question}</summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </div>
        </section>
      ) : null}

      <p className="contact-note">
        Aspirant CSS is an independent educational product by DevZona Labs. It
        is not affiliated with FPSC, PPSC or any government institution.
      </p>
    </article>
  );
}
